import styled from 'styled-components';
import { GRID_AREA_THUMBNAIL, makeDisableable } from '../styles';

export const ThumbnailContainer = styled.div`
  align-items: center;
  display: flex;
  grid-area: ${GRID_AREA_THUMBNAIL};
  height: 45px;
  justify-content: center;
  width: 45px;
`;

export const Thumbnail = styled.div`
  ${makeDisableable()}
`;
